import axios from 'axios';

import urls from '../../utils/urls';
import {tokenHeader} from "../../utils/headers";
import {ajaxHandler} from '../../utils/errors';

import {USER_STATIONS_FETCHED, USER_DETAILS_FETCHED, USER_AREAS_FETCHED, USER_ZONES_FETCHED} from './../types';
import normalizeAreaZoneStation from "../../models/schemas/schemas";

export function fetchUserDetails() {
    return (dispatch) => {
        const user_details_url = `${urls.API_ROOT}/api/v1/user-details/`;
        axios
            .get(user_details_url, tokenHeader())
            .then((response) => dispatch(userDetailsFetched(response.data)))
            .catch(ajaxHandler);
    }
}

export function userDetailsFetched(payload) {
    return {
        type: USER_DETAILS_FETCHED,
        payload: payload
    };
}

export function fetchUserStations() {
    return (dispatch) => {
        const user_stations_url = `${urls.API_ROOT}/api/v1/user-stations/`;
        axios
            .get(user_stations_url, tokenHeader())
            .then((response) => {
                    let stations = normalizeAreaZoneStation(response.data);
                    dispatch(userAreas(stations.entities.areas));
                    dispatch(userZones(stations.entities.zones));
                    dispatch(userStations(stations.entities.stations));
                }
            )
            .catch(ajaxHandler);
    }
}


export function userAreas(payload) {
    return {
        type: USER_AREAS_FETCHED,
        payload: payload
    };
}

export function userZones(payload) {
    return {
        type: USER_ZONES_FETCHED,
        payload: payload
    };
}

export function userStations(payload) {
    return {
        type: USER_STATIONS_FETCHED,
        payload: payload
    };
}


// WEBPACK FOOTER //
// ./src/actions/user_actions/index.js